import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getTestId } from '@airtel/air-design-system';
import { View } from 'react-native';
import { Strip, Comfortable, Compact } from './components';
export var IngressCardWidgetComponent = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'IngressCardWidget' : _props$testID,
    style = props.style,
    type = props.type;
  return _jsx(_Fragment, {
    children: !!type && _jsxs(View, Object.assign({}, getTestId(testID), {
      style: [style]
    }, {
      children: [type === 'strip' && _jsx(Strip, Object.assign({}, props)), type === 'comfortable' && _jsx(Comfortable, Object.assign({}, props)), type === 'compact' && _jsx(Compact, Object.assign({}, props))]
    }))
  });
};
IngressCardWidgetComponent.genericRendererKey = 'AirIngressCardWidget';